import React from "react";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";

import { Input } from "./Input";

// prettier-ignore
export const MASK = ["7", "8", "4", "-", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/];

/**
 * Text mask component for Emirates ID input formatting
 * Handles proper ref forwarding for Material-UI components
 */
export const handleRefUtil = (ref, inputRef) => {
  // Safe unwrapping of inputElement with a single return path for better coverage
  const inputElement = ref ? ref.inputElement || ref : null;

  // Handle different ref types with a single consolidated pattern
  if (inputRef) {
    if (typeof inputRef === "function") {
      inputRef(inputElement);
    } else if (typeof inputRef === "object") {
      inputRef.current = inputElement;
    }
  }
};

/**
 * Text mask component for Emirates ID input formatting
 * Handles proper ref forwarding for Material-UI components
 */
export const TextMask = ({ inputRef, ...rest }) => {
  // Use the extracted utility function for better testability
  const handleRef = ref => handleRefUtil(ref, inputRef);

  return <MaskedInput ref={handleRef} mask={MASK} guide={false} {...rest} />;
};

TextMask.propTypes = {
  /**
   * Ref forwarded from Material-UI Input component
   * Can be either a function or an object with current property
   */
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })])
};

/**
 * Emirates ID input component with formatting mask
 * Formats input according to UAE Emirates ID standard format
 */
export const EmiratesID = props => (
  <Input
    label="Emirates ID"
    placeholder="784-XXXX-XXXXXXX-X"
    InputProps={{ inputComponent: TextMask }}
    {...props}
  />
);

EmiratesID.propTypes = {
  /**
   * Validation error message to display
   */
  error: PropTypes.string,

  /**
   * Whether the field is in error state
   */
  isError: PropTypes.bool,

  /**
   * Callback function when value changes
   */
  onChange: PropTypes.func,

  /**
   * Current value of the input
   */
  value: PropTypes.string,

  /**
   * Whether the field is required
   */
  required: PropTypes.bool

  /**
   * Whether the field is disabled
   */
};
